"use client";

import { InfoBox, Link, Typography } from "@cappelendamm/design-system/react";
import NextLink from "next/link";
import { InfoCircle } from "iconoir-react";
import { Show } from "@clerk/nextjs";

export const FreeDigitalServiceInfoBox = () => {
  return (
    <InfoBox className="flex w-full items-start gap-2">
      <InfoCircle width={32} height={32} className="text-lg" />
      <Typography variant="body-sm">
        <Show when="signed-in">
          Dette produktet er gratis. Logg inn på produktets eget nettsted med
          den samme brukeren du er innlogget med nå for å få tilgang.
        </Show>
        <Show when="signed-out">
          Dette produktet er gratis.{" "}
          <Link
            variant="inline"
            as={NextLink}
            href="/login"
            className="text-black"
          >
            Opprett en bruker hos oss
          </Link>
          , og logg deretter inn på produktets eget nettsted for å få tilgang.
        </Show>
      </Typography>
    </InfoBox>
  );
};
